export default defineNuxtPlugin(() => {
  if (import.meta.client) {
    const iframe = document.createElement('iframe')
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-MPPRXL52'
    iframe.height = '0'
    iframe.width = '0'
    iframe.style.display = 'none'
    iframe.style.visibility = 'hidden'

    document.body.prepend(iframe)
  }
})
